import * as orderService from '../services/orders'


import { LIST_TYPE, ROUTES } from '../constant'


export const getOrders = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await orderService.getOrders(options)

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.ORDERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}


export const getOrder = uid => async (dispatch) => {
  dispatch({ type: 'GET_ITEM' })

  try {
    const order = await orderService.getOrder(uid)

    return dispatch({
      item: order,
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.ORDERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_ITEM_ERROR',
    })
  }
}


export const getOrderUsers = (uid, options) => async (dispatch, getState) => {
  dispatch({ type: 'LOADING' })

  try {
    const users = await orderService.getOrderUsers(uid, options)

    return dispatch({
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.ORDERS,
      item: {
        ...getState().item,
        users,
      },
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'UNLOAD',
    })
  }
}


export const editOrder = (orderId, values) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await orderService.editOrder(orderId, values)

    return dispatch({
      type: 'SNACK_SUCCESS',
      message: 'La commande à bien été modifié',
    })
  } catch (err) {
    return dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })
  }
}


export const addOrder = data => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    const order = await orderService.addOrder(data)

    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_SUCCESS',
      snackUrl: `${ROUTES.ORDER}/${order.id}`,
      message: 'Commande créé avec succès. Cliquez ici pour accéder à sa fiche.',
    })

    return true
  } catch (err) {
    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })

    return false
  }
}
